/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

var _lodashMap = require('lodash/map');

var _lodashMap2 = _interopRequireDefault(_lodashMap);

var MoreArticles = (function (_Component) {
	_inherits(MoreArticles, _Component);

	function MoreArticles() {
		_classCallCheck(this, _MoreArticles);

		_Component.apply(this, arguments);
	}

	MoreArticles.prototype.render = function render() {
		var _classNames;

		var styles = require('./MoreArticles.css');
		var _props = this.props;
		var articles = _props.articles;
		var className = _props.className;
		var isSpecialSeries = _props.isSpecialSeries;

		var baseStyles = _classnames2['default']((_classNames = {}, _classNames[styles.Base] = true, _classNames[className] = className, _classNames));

		/* Map articles from API to <article/> elements */
		var articleRoll = _lodashMap2['default'](articles, function (article, id) {
			var _classNames2;

			var titleClasses = _classnames2['default']((_classNames2 = {}, _classNames2[styles.Title] = true, _classNames2[styles['Title--sans']] = id % 2 === 0, _classNames2[styles['Title--serif']] = id % 2 !== 0, _classNames2));

			return _react2['default'].createElement(
				'article',
				{ className: styles.Article, key: article.id },
				_react2['default'].createElement(_components.MetaBar, {
					categories: article.categories,
					postDate: article.date }),
				_react2['default'].createElement(
					_reactRouter.Link,
					{ className: styles.Link, to: article.url },
					_react2['default'].createElement(
						'header',
						{ className: styles.ArticleHeader },
						_react2['default'].createElement(
							'h1',
							{ className: titleClasses },
							article.title
						)
					),
					_react2['default'].createElement('div', { className: styles.Content, dangerouslySetInnerHTML: { __html: article.excerpt } })
				)
			);
		});

		return _react2['default'].createElement(
			'div',
			{ className: baseStyles },
			_react2['default'].createElement(
				'h1',
				{ className: styles.Header },
				isSpecialSeries ? 'More in this Series' : 'More News'
			),
			_react2['default'].createElement(
				'div',
				{ className: styles.ArticleRoll },
				articleRoll
			)
		);
	};

	_createClass(MoreArticles, null, [{
		key: 'propTypes',
		value: {
			articles: _react.PropTypes.array,
			articleCount: _react.PropTypes.number,
			className: _react.PropTypes.string,
			isSpecialSeries: _react.PropTypes.bool
		},
		enumerable: true
	}, {
		key: 'defaultProps',
		value: {
			isSpecialSeries: false
		},
		enumerable: true
	}]);

	var _MoreArticles = MoreArticles;
	MoreArticles = _reactRedux.connect(function (state) {
		return {
			articles: state.moreArticles.data,
			error: state.moreArticles.error,
			loading: state.moreArticles.loading
		};
	})(MoreArticles) || MoreArticles;
	return MoreArticles;
})(_react.Component);

exports['default'] = MoreArticles;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MoreArticles/MoreArticles.js
 ** module id = 684
 ** module chunks = 0
 **/